import React, { useEffect } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { CheckCircle } from 'lucide-react';
import { useAuth } from '../contexts/AuthContext';
import { getFunctions, httpsCallable } from 'firebase/functions';

export default function PaymentSuccess() {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const { user, userType, landlordType } = useAuth();
  const functions = getFunctions();
  const source = searchParams.get('source');
  const isStarterChoice = source === 'starter';

  useEffect(() => {
    let cancelled = false;
    const run = async () => {
      if (user?.uid) {
        sessionStorage.setItem(
          `billingCheckoutSuccessAt:${user.uid}`,
          String(Date.now())
        );
        try {
          const sync = httpsCallable(functions, 'syncSubscriptionStatus');
          await sync({});
        } catch {
          // Non-blocking: route proceeds and useBilling retry handles eventual consistency.
        }
      }
      if (cancelled) return;
      // Clear any pending invite — user will see it on their dashboard
      sessionStorage.removeItem('pendingAgencyInviteId');
      if (userType === 'landlord') {
        if (landlordType === 'agency') {
          navigate('/landlord/agency/dashboard', {
            replace: true,
            state: { dashboardReveal: true, welcomeText: 'Welkom' }
          });
        } else {
          navigate('/landlord', {
            replace: true,
            state: { dashboardReveal: true, welcomeText: 'Welkom' }
          });
        }
      } else {
        navigate('/', {
          replace: true,
          state: { dashboardReveal: true, welcomeText: 'Welkom' }
        });
      }
    };

    const timer = setTimeout(run, 250);

    return () => {
      cancelled = true;
      clearTimeout(timer);
    };
  }, [navigate, userType, landlordType, user?.uid, functions]);

  return (
    <div className="min-h-screen bg-white flex items-center justify-center p-4">
      <div className="max-w-md w-full text-center">
        <div className="w-20 h-20 bg-green-100 rounded-full flex items-center justify-center mx-auto mb-6">
          <CheckCircle className="w-12 h-12 text-green-600" />
        </div>

        <h1 className="text-3xl font-bold text-gray-900 mb-4">
          {isStarterChoice ? 'Plan Gekozen!' : 'Betaling Geslaagd!'}
        </h1>
        <p className="text-gray-600 mb-6">
          {isStarterChoice ? 'Je plan is opgeslagen.' : 'Je abonnement is actief.'}
        </p>
        <div className="mx-auto h-1.5 w-56 rounded-full bg-slate-200 overflow-hidden">
          <div className="h-full bg-slate-900 animate-[grow_0.45s_linear_forwards]" />
        </div>
      </div>
      <style>{`
        @keyframes grow {
          from { width: 0%; }
          to { width: 100%; }
        }
      `}</style>
    </div>
  );
}

